export const protectFeatures = {
	kopy_shield: {
		order: 0,
		defaultValue: false,
		settingName: "Kopy Shield",
		settingDescription:
			"Protect your products and collections from getting copied by Kopy",
		icon: (
			<svg viewBox="0 0 512 512" width="28" height="28">
				<path
					fill="#56546F"
					d="M256 0c4.6 0 9.2 1 13.4 2.9l188.3 79.9c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0m0 66.8v378C394 378 431.1 230.1 432 141.4z"
				></path>
			</svg>
		),
		new: true,
	},
	block_extensions: {
		order: 1,
		defaultValue: false,
		settingName: "Block Spy Extensions",
		settingDescription:
			"Blocks Third-Party Browser Extensions that obtain data from your store such as PPSPY, Ali Hunter, UUSPY, Shopify Raise, Shopify Analyzer, UNISPY, SimplyTrends, dropship.io, SaleSource, Shopify Hunt and Shine Commerce",
		icon: (
			<svg viewBox="0 0 24 24" width="30" height="30">
				<path
					fill="#56546F"
					d="M11.83 9L15 12.16V12a3 3 0 0 0-3-3h-.17m-4.3.8l1.55 1.55c-.05.21-.08.42-.08.65a3 3 0 0 0 3 3c.22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53a5 5 0 0 1-5-5c0-.79.2-1.53.53-2.2M2 4.27l2.28 2.28l.45.45C3.08 8.3 1.78 10 1 12c1.73 4.39 6 7.5 11 7.5c1.55 0 3.03-.3 4.38-.84l.43.42L19.73 22L21 20.73L3.27 3M12 7a5 5 0 0 1 5 5c0 .64-.13 1.26-.36 1.82l2.93 2.93c1.5-1.25 2.7-2.89 3.43-4.75c-1.73-4.39-6-7.5-11-7.5c-1.4 0-2.74.25-4 .7l2.17 2.15C10.74 7.13 11.35 7 12 7Z"
				></path>
			</svg>
		),
	},
	kick_spies: {
		order: 2,
		defaultValue: false,
		settingName: "Kick Spies",
		settingDescription:
			'Kick any user by closing their tab if any spy extension (mentioned in "Block Spy Extensions" setting) is detected',
		icon: (
			<svg viewBox="0 0 24 24" width="30" height="30">
				<path
					fill="#56546F"
					d="M22.11 21.46L2.39 1.73L1.11 3L6.31 8.2L6 9H7.11L8.61 10.5H2V12H10.11L13.5 15.37C13.38 15.61 13.3 15.85 13.24 16.1C12.29 15.69 11.41 15.8 10.76 16.09C10.35 14.31 8.79 13 6.94 13C4.77 13 3 14.79 3 17C3 19.21 4.77 21 6.94 21C9 21 10.68 19.38 10.84 17.32C11.18 17.08 12.07 16.63 13.16 17.34C13.34 19.39 15 21 17.06 21C17.66 21 18.22 20.86 18.72 20.61L20.84 22.73L22.11 21.46M6.94 19.86C5.38 19.86 4.13 18.58 4.13 17C4.13 15.42 5.39 14.14 6.94 14.14C8.5 14.14 9.75 15.42 9.75 17C9.75 18.58 8.5 19.86 6.94 19.86M17.06 19.86C15.5 19.86 14.25 18.58 14.25 17C14.25 16.74 14.29 16.5 14.36 16.25L17.84 19.73C17.59 19.81 17.34 19.86 17.06 19.86M22 12H15.2L13.7 10.5H22V12M17.06 13C19.23 13 21 14.79 21 17C21 17.25 20.97 17.5 20.93 17.73L19.84 16.64C19.68 15.34 18.66 14.32 17.38 14.17L16.29 13.09C16.54 13.03 16.8 13 17.06 13M12.2 9L7.72 4.5L8.43 2.68C8.63 2.17 9.19 1.89 9.72 2.04L9.77 2.05L12 2.79L14.22 2.05C14.75 1.88 15.32 2.14 15.54 2.63L15.56 2.68L18 9H12.2Z"
				/>
			</svg>
		),
	},
	block_inspect: {
		order: 3,
		defaultValue: false,
		settingName: "Block Inspect Element",
		settingDescription:
			"Disables Inspect Element / Browser Dev Tools / F12",
		icon: (
			<svg viewBox="0 0 24 24" width="30" height="30">
				<path
					fill="#56546F"
					d="M2 7h6v2H4v2h3v2H4v4H2V7m14 0h4a2 2 0 0 1 2 2v2c0 1.11-.89 2-2 2h-2v2h4v2h-6v-4c0-1.1.9-2 2-2h2V9h-4V7m-6 0h4v10h-2V9h-2V7Z"
				></path>
			</svg>
		),
	},
	block_countries: {
		order: 4,
		defaultValue: { enabled: false, countriesBlocked: [], ipWhitelist: [] },
		settingName: "Block Countries",
		settingDescription: "Block users from different countries",
		icon: (
			<svg viewBox="0 0 24 24" width="30" height="30">
				<path
					fill="#56546F"
					d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM4 12c0-.899.156-1.762.431-2.569L6 11l2 2v2l2 2 1 1v1.931C7.061 19.436 4 16.072 4 12zm14.33 4.873C17.677 16.347 16.687 16 16 16v-1a2 2 0 0 0-2-2h-4v-3a2 2 0 0 0 2-2V7h1a2 2 0 0 0 2-2v-.411C17.928 5.778 20 8.65 20 12a7.947 7.947 0 0 1-1.67 4.873z"
				></path>
			</svg>
		),
	},
	// sales_deceiver: {
	// 	order: 4,
	// 	defaultValue: false,
	// 	settingName: "Sales Deceiver",
	// 	settingDescription: "Deceives all the Spy Tools websites & browser extensions like PPSPY, AliHunter, dropship.io, shophunter, afterlib and all of the tools that have a Shopify Store Revenue Tracker, so they can't track your store's sales accurately",
	// 	icon: <svg viewBox="0 0 24 24" width="30" height="30"><path fill="#56546F"  d="M11 13c-1.103 0-2-.897-2-2V4h5.185A2.995 2.995 0 0017 6c1.654 0 3-1.346 3-3s-1.346-3-3-3a2.997 2.997 0 00-2.816 2H5.816A2.997 2.997 0 003 0C1.346 0 0 1.346 0 3s1.346 3 3 3a2.997 2.997 0 002.816-2H7v7c0 2.206 1.794 4 4 4a1 1 0 000-2zm5.977-2c.026.001.649.04 1.316.707a1 1 0 001.414-1.414A4.49 4.49 0 0018 9.2V9a1 1 0 00-2 0v.185A2.995 2.995 0 0014 12c0 2.28 1.725 2.712 2.756 2.97h.002C17.873 15.249 18 15.354 18 16c0 .552-.448 1-.976 1-.026-.001-.65-.04-1.317-.707a1 1 0 00-1.414 1.414c.479.49 1.062.863 1.707 1.093v.2a1 1 0 002 0v-.185A2.992 2.992 0 0020 16c0-2.28-1.725-2.712-2.756-2.97h-.001C16.128 12.751 16 12.646 16 12c0-.552.449-1 .977-1z"/></svg>,
	// },
	geolocation_redirect: {
		order: 5,
		defaultValue: { enabled: false, redirects: [] },
		settingName: "Geolocation Redirect",
		settingDescription:
			"Redirect customers based on their country or IP address",
		icon: (
			<svg viewBox="0 0 24 24" width="30" height="30">
				<path
					fill="#56546F"
					d="M14.83,13.41L13.42,14.82L16.55,17.95L14.5,20H20V14.5L17.96,16.54L14.83,13.41M14.5,4L16.54,6.04L4,18.59L5.41,20L17.96,7.46L20,9.5V4M10.59,9.17L5.41,4L4,5.41L9.17,10.58L10.59,9.17Z"
				/>
			</svg>
		),
	},
	disable_shortcuts: {
		order: 6,
		defaultValue: false,
		settingName: "Disable Keyboard Shortcuts",
		settingDescription:
			"Blocks Keyboard Shortcuts that copy content such as Ctrl + S, Ctrl + P, Ctrl + A and Ctrl + U",
		icon: (
			<svg viewBox="0 0 24 24" width="30" height="30">
				<path
					fill="#56546F"
					d="M4 19q-.825 0-1.412-.587Q2 17.825 2 17V7q0-.825.588-1.412Q3.175 5 4 5h16q.825 0 1.413.588Q22 6.175 22 7v10q0 .825-.587 1.413Q20.825 19 20 19Zm4-3h8v-2H8Zm-3-3h2v-2H5Zm3 0h2v-2H8Zm3 0h2v-2h-2Zm3 0h2v-2h-2Zm3 0h2v-2h-2ZM5 10h2V8H5Zm3 0h2V8H8Zm3 0h2V8h-2Zm3 0h2V8h-2Zm3 0h2V8h-2Z"
				></path>
			</svg>
		),
	},
	protect_images: {
		order: 7,
		defaultValue: false,
		settingName: "Protect Images",
		settingDescription: "Prevents your images from being copied",
		icon: (
			<svg viewBox="0 0 512 512" width="30" height="30">
				<path
					fill="#56546F"
					d="M450.29 112H142c-34 0-62 27.51-62 61.33v245.34c0 33.82 28 61.33 62 61.33h308c34 0 62-26.18 62-60V173.33c0-33.82-27.68-61.33-61.71-61.33Zm-77.15 61.34a46 46 0 1 1-46.28 46a46.19 46.19 0 0 1 46.28-46.01Zm-231.55 276c-17 0-29.86-13.75-29.86-30.66v-64.83l90.46-80.79a46.54 46.54 0 0 1 63.44 1.83L328.27 337l-113 112.33ZM480 418.67a30.67 30.67 0 0 1-30.71 30.66H259L376.08 333a46.24 46.24 0 0 1 59.44-.16L480 370.59Z"
				></path>
				<path
					fill="#56546F"
					d="M384 32H64A64 64 0 0 0 0 96v256a64.11 64.11 0 0 0 48 62V152a72 72 0 0 1 72-72h326a64.11 64.11 0 0 0-62-48Z"
				></path>
			</svg>
		),
	},
	protect_text: {
		order: 8,
		defaultValue: false,
		settingName: "Protect Text",
		settingDescription: "Prevents text from being selected and copied",
		icon: (
			<svg viewBox="0 0 24 24" width="30" height="30">
				<path
					fill="none"
					stroke="#56546F"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="2"
					d="M10 12h4M9 4a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3m6-16a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3"
				></path>
			</svg>
		),
	},
}

export const protectFeaturesArr = Object.keys(protectFeatures)
	.map((key) => ({ ...protectFeatures[key], id: key }))
	.sort((a, b) => a.order - b.order)
